<template>
    <div class="modal fade" id="statusModal" tabindex="-1" aria-hidden="true" ref="modal">
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content modal_wrapper">
                <div class="modal-header justify-content-between align-items-center border-0 mx-4">
                    <h3 class="modal-title">{{ $t("vehicleEntry.delete") }}</h3>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <button @click="deleteEntry" class="btn btn-danger">Opravdu chci smazat!</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import StatusSelector from '@/components/StatusSelector.vue';
import { Modal } from "bootstrap/dist/js/bootstrap.bundle.min.js";

export default {
    components: {
        StatusSelector,
    },
    props: {
        vehicleEntry: Object,
    },
    mounted() {
        this.modal = new Modal(this.$refs.modal);
    },
    methods: {
        show() {
            this.$nextTick(() => {
                this.modal.show();
            });
        },
        deleteEntry() {
            this.deleteFc(this.vehicleEntry.id)
                .then(() => {
                    this.$emit("deleted");
                    this.hide();
                })
                .catch(error => {
                    console.error("Error deleting vehicle.", error);
                });
        },
        hide() {
            this.modal.hide();
        },
        deleteFc(vehicleId) {
            return this.$store.getters.api.delete(`/${this.$route.params.slug}/vehicle-entries/${vehicleId}/delete`)
        }
    },
    beforeUnmount() {
        this.modal?.hide();
    }
}
</script>